import { KelasRepositoryInterface } from '../../../data/contracts/Kelas';
import { KelasDataMapper } from '../../../data/mappers/Kelas';
import { Endpoints } from '../../misc/Endpoints';
import ApiService from '../../services/ApiService';
import { Kelas } from '../../../entities/Kelas';

export class KelasApiRepository implements KelasRepositoryInterface {
  private apiService: ApiService;
  private mapper: KelasDataMapper;
  private endpoints: Endpoints;

  constructor(
    apiService: ApiService,
    mapper: KelasDataMapper,
    endpoints: Endpoints
  ) {
    this.apiService = apiService;
    this.mapper = mapper;
    this.endpoints = endpoints;
  }

  public async getAllKelas(jenjang: string): Promise<Kelas[]> {
    const headers = new Map<string, string>();

    const dataResponse = await this.apiService.invoke(
      'get',
      this.endpoints.kelas(),
      { jenjang: jenjang },
      null,
      headers
    );
    return this.mapper.convertKelasDataFromApi(dataResponse);
  }
}
